<ac-accordion class="no-border no-content-padding" [expandable]="true" [initial]="'collapsed'" sideNav>
  <div class="icon-title" accordion-title>
    <ac-icon name="faq" size="general" />
    <span class="link-s">{{ 'HEADER.HELP' | translate }}</span>
  </div>
  <ac-help sideNav />
</ac-accordion>
@if (_userSig(); as user) {
  <ac-accordion
    class="no-border border-t border-solid border-secondary-medium-light no-content-padding"
    [expandable]="true"
    [initial]="'collapsed'"
    sideNav
  >
    <div class="icon-title" accordion-title>
      <div
        class="inline-grid place-items-center border-2 border-solid border-primary text-primary w-3 h-3 paragraph-s uppercase !font-bold"
      >
        <span>{{ user.fullName | initials }}</span>
      </div>
      <span class="link-s">{{ 'HEADER.ACCOUNT' | translate }}</span>
    </div>
    <div class="paragraph-m">
      <ac-profile-info [user]="user" sideNav />
    </div>
  </ac-accordion>
  @if (_currentIdpSig(); as idp) {
    <div
      class="sign-out border-t border-solid border-secondary-medium-light icon-title"
      role="button"
      tabindex="0"
      (click)="_logout(idp)"
      (keydown.enter)="_logout(idp)"
      (keydown.space)="_logout(idp)"
    >
      <ac-icon name="sign-out" size="general" />
      <span class="link-s"> {{ 'HEADER.LOG_OUT' | translate }}</span>
    </div>
  }
}
